import React from 'react';
import ReactDOM from 'react-dom';
import Breadcrumbs from './breadcrumbs.jsx';
import PropTypes from 'prop-types';

class ContentHeader extends React.Component {
  render() {
    let crumbs = this.props.breadcrumbs ? <Breadcrumbs /> : '';
    return (
      <section className="content-header">
        <h1>
          {this.props.heading}
          <small>
            {this.props.subheading}
          </small>
        </h1>
        {crumbs}
        {this.props.children}
      </section>
    );
  }
}
ContentHeader.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  breadcrumbs: PropTypes.bool
};
ContentHeader.defaultProps = {
  heading: '',
  subheading: '',
  breadcrumbs: false
};

export default ContentHeader;
